import React from 'react';

import { FormSearchGeoDistrictField } from 'components/Form';

const FilterSearchGeoDistrictField = (props) => {
  const { source, children, ...rest } = props;

  return (
    <FormSearchGeoDistrictField
      name={source}
      submitOnChange={true}
      forced={true}
      disableClearable={false}
      {...rest}
    />
  );
};

export default React.memo(FilterSearchGeoDistrictField);
